import * as React from "react";
const SvgFiRrUserHelmetSafety = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-helmet-safety_svg__a)">
      <path
        fill="#062147"
        d="M20.124 23.992a1 1 0 0 1-1.116-.868C18.55 19.461 15.734 17 12 17s-6.55 2.461-7.008 6.124a.999.999 0 1 1-1.984-.248C3.588 18.239 7.285 15 12 15s8.413 3.239 8.992 7.876a1 1 0 0 1-.868 1.116M4.5 7a1 1 0 0 1 1-1H6v-.5C6 2.467 8.467 0 11.5 0h1C15.533 0 18 2.467 18 5.5V6h.5a1 1 0 0 1 0 2H18c0 3.309-2.691 6-6 6s-6-2.691-6-6h-.5a1 1 0 0 1-1-1M16 8H8c0 2.206 1.794 4 4 4s4-1.794 4-4M8 6h8v-.5a3.505 3.505 0 0 0-3-3.464V4a1 1 0 0 1-2 0V2.036A3.505 3.505 0 0 0 8 5.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-helmet-safety_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserHelmetSafety;
